import * as Redux from 'redux';

import * as Store from '../../../weborder/Store';
import { fdApi } from '../../api';
import { whitelabel } from '..';
import {
  FulfilmentStatus,
  GetOrderHistoryParams,
  OrderHistoryData,
} from './order.types';
import { setOrderHistory } from './orderActions';

export const getOrderHistory = (count: number) => async (
  dispatch: Redux.Dispatch<Redux.Action>,
  getState: () => Store.State,
): Promise<void> => {
  const configData = whitelabel.selectors.getAppConfig(getState());

  if (configData) {
    const whitelabelId = configData.WhiteLabelId;
    const historyParams: GetOrderHistoryParams = {
      skip: 0,
      wlid: whitelabelId,
    };

    await fdApi
      .use(
        fdApi.order.getOrderHistory(count, {
          params: historyParams,
        }),
      )
      .then((data: OrderHistoryData[]) => {
        dispatch(
          setOrderHistory({
            data,
            status: 'success',
          }),
        );
      })
      .catch(() => {
        dispatch(
          setOrderHistory({
            status: 'none',
          }),
        );
      });
  }
};

export const getFulfilmentStatus = (
  orderId: number,
): Promise<FulfilmentStatus> =>
  fdApi
    .use(fdApi.order.getFulfilmentStatus(orderId))
    .then((data: FulfilmentStatus) => data);
